import { Classes, ContextMenu, Icon, Menu, Spinner } from "@blueprintjs/core"
import { History } from "history"
import { observer } from "mobx-react"
import { EmptySquare } from "modules/common/components/icons/square"
import { PlanrButton } from "modules/common/components/planr/button/Button"
import { GeneralIcon } from "modules/common/components/planr/icon/Generalcon"
import { routes } from "modules/common/routes"
import { eat } from "modules/common/services/typescript"
import internalFunc from "modules/main/functionalities"
import { can, canAny } from "modules/session/auth/access"
import { SessionType } from "modules/session/auth/models/session"
import func from "modules/session/functionalities"
import React from "react"
import { RouteComponentProps, withRouter } from "react-router"
import styles from "./User.module.scss"
import Profile from "./Profile"
import { EmployerType } from "modules/spending/employee/models/employer"

class Me extends React.Component<UserProps & RouteComponentProps, UserState> {
  constructor(props: UserProps & RouteComponentProps) {
    super(props)

    this.state = {
      loading: false,
      showProfile: false,
      employer: null,
    }
  }
  render() {
    const { store, employerStore } = this.props
    const { loading, showProfile, employer } = this.state
    return (
      <div className={`app-user centered planr-user`}>
        {store.tgBotLink && (
          <a href={store.tgBotLink} title="Регистрация в чат-боте">
            <i
              className={`fa fa-telegram`}
              style={{
                fontSize: "40px",
                marginRight: "20px",
                color: "#279FDA",
              }}
              aria-hidden="true"
            />
          </a>
        )}
        {store.appVersion && store.appFileId && (
          <PlanrButton
            type={"neutral"}
            round
            title="Скачать приложение"
            onClick={
              !loading
                ? async () => {
                  this.setState({ loading: true })
                  await store.downloadFile([store.appFileId])
                  this.setState({ loading: false })
                }
                : eat
            }
          >
            {loading ? (
              <Spinner intent="primary" size={30} />
            ) : (
              <i
                className={`fa fa-android`}
                style={{
                  fontSize: "30px",
                  marginRight: "20px",
                  color: "#1dd278",
                }}
                aria-hidden="true"
              />
            )}
          </PlanrButton>
        )}

        <div className="user-details">
          <div style={{ color: "#00273d" }}>{store.userName} </div>
          <div className="user-details-post">{store.userLogin}</div>
        </div>
        {store.userAvatar ? (
          <img src={store.userAvatar} alt={"avatar"} className={styles.avatarImage} />
        ) : (
          <Icon icon="user" iconSize={44} />
        )}

        <GeneralIcon
          type="general-settings-dots"
          className={`app-user centered planr-settingsicon`}
          onClick={this.showMenu}
          size={50}
        />

        {employer && (
          <Profile
            employer={employerStore}
            show={showProfile}
            onClose={() => {
              this.setState({ showProfile: !this.state.showProfile, employer: null })
            }}
            onSave={() => {
              this.setState({ showProfile: !this.state.showProfile, employer: null })
            }}
          />
        )}
      </div>
    )
  }

  showMenu = (e: React.MouseEvent<SVGSVGElement>) => {
    const menu = this.renderContextMenu()
    ContextMenu.show(menu, { left: e.clientX, top: e.clientY + 12 })
  };

  public renderContextMenu() {
    return (
      <UserMenu
        {...this.props}
        showProfile={this.state.showProfile}
        openProfile={async () => {
          const res = await this.props.employerStore.loadProfile(this.props.store.userId)
          if (res) this.setState({ showProfile: true, employer: this.props.employerStore })
        }}
      />
    )
  }
}

export const ACCESS_MENU_LABEL = "Настройки доступа"

const UserMenu = observer(
  class extends React.Component<UserMenuProps> {
    render() {
      const { access } = this.props.store

      return (
        <Menu className={Classes.ELEVATION_1} style={{ fontFamily: "GothamPro, Arial, sans-serif" }}>
          {can(internalFunc.INTERNAL_USER_ACCESS, access) && (
            <Menu.Item icon={<Icon icon="user" />} onClick={this.changeProfile} text="Редактирование профиля" />
          )}
          {can(func.SETTINGS_EDIT, access) && (
            <Menu.Item icon={<Icon icon="cog" />} onClick={this.gotoSettings} text="Настройки приложения" />
          )}

          {canAny([internalFunc.INTERNAL_USER_ACCESS, func.ACCESS_EDIT], access) && (
            <Menu.Item
              icon="lock"
              onClick={this.gotoAccess}
              text={can(func.ACCESS_EDIT, access) ? ACCESS_MENU_LABEL : "Таблица разрешений"}
            />
          )}

          {can(func.TOKENS_CONFIRMATION, access) && (
            <Menu.Item icon="desktop" onClick={this.gotoTokens} text="Подтверждение устройств" />
          )}

          <Menu.Item icon={<EmptySquare />} onClick={this.logOut} text="Выход" />
        </Menu>
      )
    }

    gotoAccess = () => {
      this.props.history.push(routes.access)
    };

    gotoSettings = () => {
      this.props.history.push(routes.settings)
    };

    gotoTokens = () => {
      this.props.history.push(routes.tokens.outer)
    };

    changeProfile = async () => {
      this.props.openProfile()
    };

    logOut = async () => {
      if (await this.props.store.logOut()) {
        this.props.onLogout()
      }
    };
  }
)

interface UserMenuProps {
  store: SessionType
  history: History
  onLogout: () => void
  openProfile: () => void
  showProfile: boolean
}

interface UserProps {
  store: SessionType
  onLogout: () => void
  employerStore: EmployerType
}

interface UserState {
  loading: boolean
  showProfile: boolean
  employer: EmployerType | null
}

export const User = withRouter(observer(Me))
